import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchManualPreadviceTransactions = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getManualPreadviceTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
    queryStringParams: {
      selectedDays: payload.params.selectedDays,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchManualPreadviceTransactions;
